<template>
  <div style="width: 100%">
    <v-toolbar flat class="d-flex justify-center" color="transparent">
      <v-btn outlined class="overline" color="grey darken-2" :disabled="isLoading" @click="setToday">
        Hoy
      </v-btn>
      <v-btn fab text small color="grey darken-2" :disabled="isLoading" @click="prevMonth">
        <v-icon small>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$refs.calendar" class="font-weight-light primary--text">
        {{ calendarTitle }}
      </v-toolbar-title>
      <v-btn fab text :small="$vuetify.breakpoint.smAndDown" color="grey darken-2" :disabled="isLoading" @click="nextMonth">
        <v-icon small>mdi-chevron-right</v-icon>
      </v-btn>
      <v-spacer />
      <div class="d-flex">
        <v-btn
          v-if="selectedDay"
          outlined
          :small="$vuetify.breakpoint.smAndDown"
          class="mr-1"
          color="grey darken-2"
          @click="viewMonth"
        >
          <v-icon :left="!$vuetify.breakpoint.smAndDown">mdi-arrow-left</v-icon>
          {{ !$vuetify.breakpoint.smAndDown ? 'Volver' : '' }}
        </v-btn>
        <v-btn
          outlined
          class="mr-4"
          color="success"
          :small="$vuetify.breakpoint.smAndDown"
          :disabled="isLoading"
          @click="openCreateHolidays"
        >
          <v-icon :left="!$vuetify.breakpoint.smAndDown">mdi-calendar</v-icon>
          {{ !$vuetify.breakpoint.smAndDown ? 'Establecer Vacaciones' : '' }}
        </v-btn>
      </div>
    </v-toolbar>

    <v-row no-gutters>
      <v-col v-if="hasAdminPermission" cols="12" md="6">
        <div style="padding: 20px 43px 19px 43px !important" class="ma-2" elevation="0">
          <v-autocomplete
            class="pa-4"
            :items="assignedComerciales"
            v-model="selectedComercial"
            item-text="nombreCompleto"
            :disabled="!assignedComerciales.length"
            return-object
            prepend-inner-icon="mdi-account"
            hint="Selecciona un comercial para ver sus vacaciones, por defecto se mostrará el de la cuenta logueada"
            persistent-hint
            :menu-props="{ maxHeight: '600' }"
            label="Comercial"
            clearable
          >
            <template #item="{ item }">
              <v-row dense>
                <v-col cols="11">{{ item.nombreCompleto }}</v-col>
                <v-col v-if="item.estado" cols="1">
                  <v-chip
                    v-if="!$vuetify.breakpoint.smAndDown"
                    label
                    :color="ESTADO_COLORS[item.estado]"
                    medium
                    class="d-flex justify-center overline"
                  >
                    {{ item.estado }}
                  </v-chip>
                  <v-icon
                    v-else
                    :color="ESTADO_COLORS[item.estado]"
                    large
                    class="d-flex justify-center"
                  >
                    mdi-circle
                  </v-icon>
                </v-col>
              </v-row>
            </template>
          </v-autocomplete>
          <v-progress-linear indeterminate :active="isLoading" style="width: 100%" />
        </div>
      </v-col>

      <v-col cols="12" :md="hasAdminPermission ? '6' : '12'">
        <div class="pa-4 ma-2" elevation="0">
          <v-row class="d-flex">
            <v-col v-for="(value, key) in spentHolidays" :key="key" cols="12" md="4">
              <div class="pa-4" flat>
                <h3 class="font-weight-light primary--text">{{ getTitle(key) }}</h3>
                <v-divider />
                <h2 class="font-weight-light">{{ value }}</h2>
              </div>
            </v-col>
          </v-row>
          <v-progress-linear indeterminate :active="isLoading" style="width: 100%" />
        </div>
      </v-col>
    </v-row>

    <div :disabled="isLoading" class="ma-2 pa-2" elevation="0">
      <v-sheet height="75vh">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          locale="es-es"
          :event-color="getEventColor"
          :type="calendarType"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="setHolidays"
        />

        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
          max-width="500"
        >
          <div max-width="500" class="white">
            <v-toolbar :color="selectedEvent.color" flat>
              <v-btn icon>
                <v-icon color="white" size="30">mdi-account</v-icon>
              </v-btn>
              <v-spacer />
              <v-toolbar-title
                class="justify-center font-weight-light white--text"
                v-html="selectedEvent.name"
              />
              <v-spacer />

              <template v-if="!isFestiveDay">
                <v-btn v-if="selectedEvent.file" icon @click="openAttachedFile">
                  <v-icon color="white" size="30">mdi-paperclip</v-icon>
                </v-btn>

                <v-btn
                  v-if="hasAdminPermission || hasManagerPermission || hasSuperAdminPermission"
                  icon
                  @click="toggleApproval"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="white" size="30" v-bind="attrs" v-on="on">
                        {{ selectedEvent.is_accepted ? 'mdi-check-decagram-outline' : 'mdi-cancel' }}
                      </v-icon>
                    </template>
                    <span>{{ selectedEvent.is_accepted ? 'Aprobado' : 'No aprobado' }}</span>
                  </v-tooltip>
                </v-btn>

                <v-btn icon @click="editHolidays">
                  <v-icon color="white" size="30">mdi-pen</v-icon>
                </v-btn>
                <v-btn icon @click="openDeleteDialog">
                  <v-icon color="white" size="30">mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-toolbar>

            <div class="pa-4">
              <h2 class="font-weight-light" v-html="selectedEvent.details" />
            </div>
            <div class="pb-2 d-flex justify-end">
              <v-btn small text color="red" @click="selectedOpen = false">Cerrar</v-btn>
            </div>
          </div>
        </v-menu>
      </v-sheet>
    </div>

    <HolidaysForm />
    <DeleteDialog />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import HolidaysForm from './HolidaysForm.vue';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';
import { clone } from '@/util/libUtil.js';

// Maps duration (days) ranges to Vuetify color strings
const COLOR_BY_DURATION = [
  { max: 2,  color: 'green lighten-1' },
  { max: 6,  color: 'green darken-1'  },
  { max: 7,  color: 'yellow lighten-1'},
  { max: 13, color: 'yellow darken-1' },
  { max: 20, color: 'purple'          },
];
const COLOR_FALLBACK = 'indigo';

const SPENT_HOLIDAYS_LABELS = {
  spent_holidays: 'Disfrutadas',
  holiday_type:   'Tipo',
  remain:         'Restantes',
};

const ESTADO_COLORS = Object.freeze({
  ALTA:       'success',
  BAJA:       'warning',
  INACTIVO:   'error',
  VACACIONES: 'blue',
});

// Detects whether a holiday detail string contains a YYYY-MM-DD date (non-festive)
const DATE_RANGE_REGEX = /\b\d{4}-\d{2}-\d{2}\b/;

// Spain timezone for timed-event detection
const TZ_OPTIONS = {
  year: 'numeric', month: 'numeric', day: 'numeric',
  hour: 'numeric', minute: 'numeric', second: 'numeric',
  timeZone: 'Europe/Madrid',
};
const MIDNIGHT_OFFSETS = new Set(['0:00:00', '1:00:00', '2:00:00']);

export default {
  name: 'HolidaysCalendar',

  components: { HolidaysForm, DeleteDialog },

  data: () => ({
    ESTADO_COLORS,
    focus: '',
    calendarType: 'month',
    selectedEvent:   {},
    selectedElement: null,
    selectedOpen:    false,
    selectedDay:     false,
    events:          [],
  }),

  computed: {
    calendarTitle() {
      const title = this.$refs.calendar?.title ?? '';
      return title.charAt(0).toUpperCase() + title.slice(1);
    },
    isFestiveDay() {
      return !DATE_RANGE_REGEX.test(this.selectedEvent.details);
    },
    assignedComerciales() {
      return this.comerciales.filter(({ nombreCompleto }) => nombreCompleto !== 'Por asignar');
    },
    cuenta() {
      return JSON.parse(localStorage.getItem('cuenta'));
    },

    selectedComercial: {
      get()    { return this.$store.state.holidays.selectedComercial; },
      set(val) { this.$store.commit('holidays/selectedComercial', val); },
    },
    rangoDate: {
      get()    { return this.$store.state.holidays.rangoDate; },
      set(val) { this.$store.commit('holidays/rangoDate', val); },
    },
    holidaysForm: {
      get()    { return this.$store.state.holidays.holidaysForm; },
      set(val) { this.$store.commit('holidays/holidaysForm', val); },
    },

    ...mapState('teletrabajo', {
      comerciales: (state) => state.Comerciales,
    }),
    ...mapState('holidays', {
      isLoading:    (state) => state.isLoading,
      spentHolidays:(state) => state.spentHolidays,
      holidays:     (state) => state.holidays,
      festiveDays:  (state) => state.workingCalendarObj.workingCalendar,
    }),
    ...mapGetters('login', [
      'hasAdminPermission',
      'hasManagerPermission',
      'hasSuperAdminPermission',
    ]),
  },

  watch: {
    holidays() {
      this.events = [
        ...this.holidays.map(this.mapHolidayToEvent),
        ...this.festiveDays.map(this.mapFestiveDayToEvent),
      ];
    },
    selectedComercial() {
      this.fetchHolidays(this.rangoDate);
      this.getSpentHolidays();
    },
  },

  created() {
    this.$store.dispatch('teletrabajo/fetchComerciales').then(() => {
      if (!this.selectedComercial) {
        this.selectedComercial = this.comerciales.find(({ id }) => id === this.cuenta.id);
      }
    });
  },

  mounted() {
    this.$refs.calendar.checkChange();
  },

  methods: {
    // ── Event mapping ──────────────────────────────────────────────────────────
    mapHolidayToEvent(event) {
      const begin = new Date(event.begin);
      const end   = new Date(event.end);
      const typeLabel = event.type.toLowerCase().replaceAll('_', ' ');
      const details = event.begin !== event.end
        ? `Desde ${event.begin} hasta ${event.end}, ${typeLabel}`
        : `${event.begin}, ${typeLabel}`;

      return {
        name:        event.commercial.nombreCompleto,
        commercial:  event.commercial,
        holidays_id: event.id,
        details,
        start:       begin,
        end,
        is_accepted: event.isAccepted,
        type:        event.type,
        color:       this.colorByDuration(begin, end),
        file:        event.file,
        timed:       this.isTimedEvent(begin),
      };
    },
    mapFestiveDayToEvent(event) {
      const date = new Date(event.date);
      return {
        name:    event.name,
        details: event.description,
        start:   date,
        end:     date,
        color:   'red',
        timed:   false,
      };
    },

    // ── Color & label helpers ──────────────────────────────────────────────────
    colorByDuration(begin, end) {
      const days = Math.round((end - begin) / 86400000);
      return COLOR_BY_DURATION.find(({ max }) => days < max)?.color ?? COLOR_FALLBACK;
    },
    isTimedEvent(date) {
      const timeStr = new Intl.DateTimeFormat('es-ES', TZ_OPTIONS).format(date).split(' ')[1];
      return !MIDNIGHT_OFFSETS.has(timeStr);
    },
    getEventColor: (event) => event.color,
    getTitle: (key) => SPENT_HOLIDAYS_LABELS[key] ?? key,

    // ── Calendar navigation ────────────────────────────────────────────────────
    setToday()  { this.focus = ''; },
    prevMonth() { this.$refs.calendar.prev(); },
    nextMonth() { this.$refs.calendar.next(); },
    viewDay({ date }) {
      this.focus       = date;
      this.calendarType = 'day';
      this.selectedDay = true;
    },
    viewMonth() {
      this.calendarType = 'month';
      this.selectedDay  = false;
    },
    setHolidays({ start, end }) {
      if (this.calendarType === 'day') return;
      const isSameRange =
        this.rangoDate?.start === start && this.rangoDate?.end === end;
      this.rangoDate = { start, end };
      if (!isSameRange) this.fetchHolidays(this.rangoDate);
    },

    // ── Event popup ────────────────────────────────────────────────────────────
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent   = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(open));
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },

    // ── Holiday actions ────────────────────────────────────────────────────────
    openCreateHolidays() {
      this.$store.commit('holidays/holidaysFormType', 'CREATE');
      this.$store.commit('holidays/isOpenHolidaysForm', true);
    },
    editHolidays() {
      this.$store.commit('holidays/holidaysForm', {
        ...this.holidaysForm,
        commercial: this.selectedEvent.commercial,
        begin:      this.selectedEvent.start,
        end:        this.selectedEvent.end,
        id:         this.selectedEvent.holidays_id,
      });
      this.$store.commit('holidays/holidaysFormType', 'EDIT');
      this.$store.commit('holidays/isOpenHolidaysForm', true);
    },
    toggleApproval() {
      this.selectedEvent = {
        ...this.selectedEvent,
        is_accepted: !this.selectedEvent.is_accepted,
      };
      this.changeHolidaysApproval(this.selectedEvent.holidays_id);
    },
    openDeleteDialog() {
      this.$store.commit('util/deleteDialog', clone({
        toDeleteId:          this.selectedEvent.holidays_id,
        toDeleteType:        'HOLIDAYS',
        isOpenDeleteDialog:  true,
        additionalParams:    this.rangoDate,
      }));
    },
    openAttachedFile() {
      window.open(this.selectedEvent.file, '_blank');
    },

    ...mapActions('holidays', ['fetchHolidays', 'getSpentHolidays', 'changeHolidaysApproval']),
  },
};
</script>